<section class="loan-operation-origins">
  <div class="loan-operation-origins__header">
    <app-breadcrumb [home]="home" [items]="breadcrumbs"></app-breadcrumb>
  </div>

  <div class="loan-operation-origins__header">
    <div class="loan-operation-origins__header__title">
      <div class="loan-operation-origins__header__title__icon" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
      </div>
      <div>
        <h1>{{ tk.Management.ManageExternalOrigins | t }}</h1>
        <p class="loan-operation-origins__header__subtitle" *ngIf="financialInstitutionName">
          {{ tk.Management.FinancialInstitution | t }}: {{ financialInstitutionName }}
        </p>
      </div>
    </div>
    <div class="loan-operation-origins__header__actions" *appHasRole="Roles.ADMIN">
      <app-button
        [id]="'add-origin'"
        [label]="tk.Management.RegisterOrigin | t"
        [icon]="'pi pi-plus'"
        [type]="'button'"
        (sendButtonClick)="openCreateModal()">
      </app-button>
    </div>
  </div>

  <div class="loan-operation-origins__content">
    <div *ngIf="origins.length > 0; else noOrigins">
      <app-table
        [items]="origins"
        [columnDefinitions]="columnDefinitions"
        [options]="tableOptions"
        [totalRecords]="origins.length"
        [rows]="10"
        [hasPagination]="false"
        (sendTableAction)="handleTableAction($event)">
      </app-table>
    </div>

    <ng-template #noOrigins>
      <div class="loan-operation-origins__empty">
        <h4>{{ tk.Management.NoOriginsRegistered | t }}</h4>
        <p class="loan-operation-origins__empty__description">
          {{ tk.Management.RegisterFirstOriginFunding | t }}
        </p>
        <div class="loan-operation-origins__empty__button" *appHasRole="Roles.ADMIN">
          <app-button
            [id]="'add-origin-empty'"
            [label]="tk.Management.RegisterOrigin | t"
            [icon]="'pi pi-plus'"
            [type]="'button'"
            (sendButtonClick)="openCreateModal()">
          </app-button>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Modal de criar/editar origem -->
  <app-modal-create-loan-operation-origin
    #modalCreateOrigin
    [financialInstitutionId]="financialInstitutionId"
    (originCreated)="handleOriginCreated($event)">
  </app-modal-create-loan-operation-origin>
</section>
